import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Job } from '../../core/job/';
import { SiteService } from '../../core/site/';
import { RestoreRouteParams } from '../../core/routeparams';
import { interval } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ErrorDialog } from '../dialog';
import { map, mergeMap, takeWhile } from 'rxjs/operators';

@Component({
  templateUrl: './restore.component.html',
  styleUrls: ['../animation.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RestoreComponent implements OnInit {
  isJobStatusComplete = false;
  hideCanvas = false;
  private siteId: string;
  private jobId: string;
  private jobStatus: string;
  private dialogRef: MatDialogRef<ErrorDialog>;

  constructor(
    private route: ActivatedRoute,
    private siteService: SiteService,
    private dialog: MatDialog,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.siteId = (this.route.snapshot.params as RestoreRouteParams).siteId;
    this.jobId = (this.route.snapshot.params as RestoreRouteParams).jobId;
    this.pollForJobCompletion();
  }

  pollForJobCompletion(): void {
    interval(3000)
      .pipe(
        mergeMap(() => this.siteService.getJobForSite(this.siteId, this.jobId)),
        map((backupJob) => {
          const backupStatus = (backupJob as Job).status;
          this.jobStatus = backupStatus;
          return backupStatus;
        }),
        takeWhile((jobStatus) => jobStatus === Job.IN_PROGRESS),
      )
      .subscribe(
        (res) => res,
        () => {
          this.hideCanvas = true;
          this.displayError('There was an error trying to restore your backup');
        },
        () => this.restoreComplete(this.jobStatus),
      );
  }

  restoreComplete(jobStatus: string): void {
    if (jobStatus === Job.COMPLETE) {
      this.isJobStatusComplete = true;
      window.setTimeout(() => this.navigateToDashboard(), 2000);
    } else if (jobStatus === Job.FAILED) {
      this.hideCanvas = true;
      this.displayError('There was an error trying to restore your backup');
    }
  }

  displayError(error: string): void {
    this.dialogRef = this.dialog.open(ErrorDialog, {
      data: {
        errMsg: error,
        overrideButtonKey: 'BUTTONS.BACK',
      },
    });
    this.dialogRef.afterClosed().subscribe(() => {
      this.navigateToDashboard();
    });
  }

  navigateToDashboard(): void {
    this.router.navigateByUrl('/site/' + this.siteId + '/overview');
  }
}
